import { render, staticRenderFns } from "./duizhang.vue?vue&type=template&id=41d1e244&scoped=true&"
import script from "./duizhang.vue?vue&type=script&lang=js&"
export * from "./duizhang.vue?vue&type=script&lang=js&"
import style0 from "@/assets/components.scss?vue&type=style&index=0&id=41d1e244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d1e244",
  null
  
)

export default component.exports